export default __webpack_public_path__ + "i/42e7876f7d55c587d2aa8161223ad4cb.png";